module.exports = __webpack_public_path__ + "img/pic1.1cb66931.png";